import Chip from '@mui/material/Chip';
import useOnboardingSx from '../../hooks/useOnboardingSx';

const styles = {
  required: { label: 'Required', color: 'primary' },
  optional: { label: 'Optional', color: 'default' },
  completed: { label: 'Completed', color: 'success' },
  skipped: { label: 'Skipped', color: 'warning' },
  draft: { label: 'Draft', color: 'warning' },
};

export default function StatusChip({ variant }) {
  const sx = useOnboardingSx();
  const s = styles[variant] ?? styles.optional;
  return (
    <Chip
      label={s.label}
      color={s.color}
      size="small"
      variant="outlined"
      sx={sx.statusChip}
    />
  );
}
